import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6bdfdb5c")

_pushScopeId("data-v-6bdfdb5c")
const _hoisted_1 = { class: "d-list-item-root" }
const _hoisted_2 = { class: "item-header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "round" }
const _hoisted_5 = { class: "header-right" }
const _hoisted_6 = { class: "good-road-label" }
const _hoisted_7 = {
  key: 0,
  class: "good-road-name-text"
}
const _hoisted_8 = { class: "map" }
const _hoisted_9 = { class: "limit-pop-content" }
const _hoisted_10 = { class: "limit-pop-head" }
const _hoisted_11 = { class: "limit-pop-list" }
const _hoisted_12 = { class: "limit-pop-item-label" }
const _hoisted_13 = { class: "limit-pop-item-value" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_timer_loading_bar = _resolveComponent("timer-loading-bar")
  const _component_road_map_view = _resolveComponent("road-map-view")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createVNode("span", _hoisted_4, _toDisplayString(_ctx.xueAndJu), 1),
      _createVNode("div", _hoisted_5, [
        _createVNode("span", _hoisted_6, [
          _withDirectives(_createVNode("span", null, [
            (_ctx.goodRoadName)
              ? (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(_ctx.goodRoadName), 1))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, _ctx.goodRoadName]
          ])
        ]),
        _createVNode("span", {
          class: ["timer", _ctx.timerClass]
        }, _toDisplayString(_ctx.currentTime !== -1 ? _ctx.currentTime : ''), 3)
      ])
    ]),
    _createVNode(_component_timer_loading_bar, {
      class: "line",
      count: _ctx.currentTime
    }, null, 8, ["count"]),
    _createVNode("div", _hoisted_8, [
      _createVNode(_component_road_map_view, {
        class: "road-map",
        mapData: _ctx.deskResult,
        display: 3
      }, null, 8, ["mapData"]),
      (_ctx.selectedIndex === _ctx.itemIndex)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "limit-pop",
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => { }, ["stop"]))
          }, [
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, _toDisplayString(_ctx.iN('tables.selectlimit')), 1),
              _createVNode("div", _hoisted_11, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.userLimits, (item, index) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "limit-pop-list-item",
                    key: index,
                    onClick: ($event: any) => (_ctx.enterDesk(item))
                  }, [
                    _createVNode("span", _hoisted_12, _toDisplayString(_ctx.iN('tables.limit')), 1),
                    _createVNode("span", _hoisted_13, _toDisplayString(item.downLimit) + " - " + _toDisplayString(item.upLimit), 1)
                  ], 8, ["onClick"]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})